<div class="relative">
  <mat-card>
    @if (selectedOrderLoading()) {
      <div class="absolute inset-0 flex items-center justify-center bg-white/80 z-50">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    } @else if (selectedOrderError()) {
      <div class="flex justify-center p-4">
        <p class="text-red-500">{{ errorText }}</p>
      </div>
    } @else if (order && order !== null) {
      <div class="p-6">
        <div class="flex flex-col gap-2">
          <div class="text-xl font-bold">
            Job #: <span class="font-normal">{{ order.orderId }}</span>
          </div>
          <div>
            Created By:
            <span class="font-medium"
              >{{ order.createdBy.firstName }} {{ order.createdBy.lastName }}</span
            >
          </div>
          <div>
            Created On: <span class="font-medium">{{ order.dateCreated | date: 'medium' }}</span>
          </div>
          <div>
            Quote ID:
            <a
              [routerLink]="['/quotes', order?.quote.id, 'view']"
              class="text-blue-600 underline"
              >{{ order?.quote.quoteId }}</a
            >
          </div>
        </div>

        <form [formGroup]="form" class="py-6 flex flex-col gap-6">
          <mat-card class="mb-4">
            <ciwc-order-manage-general
              [form]="generalForm"
              [orderDetails]="order"
              [isSaving]="selectedOrderSaving()"
              (save)="onSubmit()"
              (cancel)="onGeneralCancel()"
            >
            </ciwc-order-manage-general>
            <div class="mt-4">
              <ciwc-order-job-details
                [form]="jobDetailsForm"
                [orderDetails]="order"
                [setFormValues]="setFormValues"
              ></ciwc-order-job-details>
            </div>

            <div class="mt-4">
              <ciwc-production-flow
                [parentForm]="form"
                [orderDetails]="order"
                [details]="order.details[0]"
                [createShipmentGroup]="boundCreateShipmentGroup"
                [itemProcesses]="itemProcessesPayload"
                [readonlySpecFields]="readonlySpecFields"
                (constructionStepsChange)="onConstructionStepsChange($event)"
              ></ciwc-production-flow>
            </div>

            <div class="mt-4">
              <ciwc-order-item-processes
                [parentForm]="form"
                [orderDetails]="order"
                [itemProcesses]="order.itemProcesses"
                [viewDisable]="false"
              >
              </ciwc-order-item-processes>
            </div>

            <div class="mt-4">
              <ciwc-order-job-follow-up
                [followUps]="followUps"
                [orderDetails]="order"
                (addFollowUp)="addFollowUp()"
                (removeFollowUp)="removeFollowUp($event)"
              >
              </ciwc-order-job-follow-up>
            </div>

            <div class="mt-4">
              <div class="flex flex-col md:flex-row gap-8">
                <div class="w-full md:w-1/2">
                  <ciwc-order-note-history [orderDetails]="order"></ciwc-order-note-history>
                </div>
                <div class="w-full md:w-1/2">
                  <ciwc-order-change-history [orderDetails]="order"></ciwc-order-change-history>
                </div>
              </div>
            </div>
          </mat-card>
          <!-- More sections/components will go here -->

          <div class="flex justify-end gap-4 mt-6">
            <button
              mat-flat-button
              type="button"
              (click)="onGeneralCancel()"
              [disabled]="isSaving()"
            >
              Cancel
            </button>
            <button
              mat-flat-button
              color="primary"
              type="button"
              (click)="onSubmit()"
              [disabled]="isSaving()"
              class="relative flex items-center justify-center min-w-[140px]"
            >
              <ng-container *ngIf="selectedOrderSaving(); else saveText">
                <mat-progress-spinner
                  diameter="20"
                  class="!inline-block align-middle"
                  mode="indeterminate"
                  color="accent"
                  [strokeWidth]="3"
                ></mat-progress-spinner>
                <span>Saving</span>
              </ng-container>
              <ng-template #saveText>Save Changes</ng-template>
            </button>
          </div>
        </form>
      </div>
    }
  </mat-card>
</div>
